import { VideoProps } from '@design-system/video';

import { buttonMapper } from '../button';
import { imageMapper } from '../image';
import { Video } from './models';

export const videoMapper = ({
  iframeTitle,
  noJavascriptLabel,
  preview: { previewButton, previewImage },
  title,
  transcription: { ariaControlId, transcriptionContent, transcriptionLabel },
  videoLink,
}: Video) =>
  ({
    noJsLabel: noJavascriptLabel,
    preview: {
      previewBtn: buttonMapper(previewButton),
      previewImage: imageMapper(previewImage),
    },
    iframeTitle,
    link: videoLink,
    title,
    transcript: ariaControlId &&
      transcriptionContent &&
      transcriptionLabel && {
        ariaControlId,
        transcriptContent: transcriptionContent,
        transcriptLabel: transcriptionLabel,
      },
  } as VideoProps);
